export default [
  // path redirects
  //{ from: "/a/path", to: "a-route-name", isPath: true },
  // named-routes redirects
  //{ from: "a-route-name", to: "/a/path", isPath: false },
  //{ from: "a-route-name", to: "a-route-name", isPath: false },
  //{ from: "a-path-or-regex-string", to: "a-path-or-regex-replacement", isHard: true, isReg: true }
];
